import { CredentialResponse, GoogleLogin } from '@react-oauth/google';
import React from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useLoadingContext } from '../../login/context/LoadingContext.tsx';
import { UserInfo, useUserContext } from '../../user/context/UserContext.tsx';
import { HOST } from '../../utils/constants.ts';
import './google-login-button.scss';

const GoogleLoginButton: React.FC = () => {
  const { setUserInfo } = useUserContext();
  const { showLoading, hideLoading } = useLoadingContext();
  const navigate = useNavigate();

  const handleGoogleSuccess = async (
    credentialResponse: CredentialResponse
  ) => {
    try {
      showLoading();

      if (!credentialResponse.credential) {
        throw new Error('No se recibió credencial de Google');
      }

      // Enviar el token JWT al backend
      const response = await fetch(`${HOST}/auth/google`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: credentialResponse.credential }),
      });

      if (!response.ok) {
        let errorMessage = 'Error al iniciar sesión con Google';
        try {
          const errorData = await response.json();
          errorMessage = errorData.message || errorMessage;
        } catch {
          errorMessage =
            'El servidor no está disponible. Intenta de nuevo más tarde.';
        }
        throw new Error(errorMessage);
      }

      const userInfo: UserInfo = await response.json();

      setUserInfo(userInfo);
      localStorage.setItem('token', userInfo.token);
      localStorage.setItem('userInfo', JSON.stringify(userInfo.user));

      navigate('/');
      toast.success('¡Sesión iniciada correctamente con Google!');
    } catch (error: any) {
      toast.error(`Error al iniciar sesión con Google: ${error.message}`, {
        duration: 4000,
      });
    } finally {
      hideLoading();
    }
  };

  const handleGoogleError = () => {
    toast.error('Error al conectar con Google', { duration: 4000 });
  };

  return (
    <div className="google-login-container">
      <GoogleLogin
        onSuccess={handleGoogleSuccess}
        onError={handleGoogleError}
        useOneTap={false}
        size="large"
        text="continue_with"
      />
    </div>
  );
};

export default GoogleLoginButton;
